/**
 * @generated SignedSource<<6820cb2d0c31f163f04f8c0501ab54fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateRowFlight_packageDate$data = {
  readonly flight: {
    readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlightPrice_flight">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlightDetails_packageDate">;
  readonly " $fragmentType": "PackageDateRowFlight_packageDate";
};
export type PackageDateRowFlight_packageDate$key = {
  readonly " $data"?: PackageDateRowFlight_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateRowFlight_packageDate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateRowFlight_packageDate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Flight",
      "kind": "LinkedField",
      "name": "flight",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PackageDateRowFlightPrice_flight"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateRowFlightDetails_packageDate"
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};

(node as any).hash = "3ad1abc238dd271bbd59c81adaaf74f2";

export default node;
